// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColumnsPersonalizer_checkboxEditColumns__ewKms {
  color: #787878;
  font-weight: 400;
  font-size: 13px;
  flex-grow: 1;
  height: 100%;
  display: flex;
  align-items: center;
}
.ColumnsPersonalizer_columnEditLine__pw2zC {
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  column-gap: 8px;
  height: 38px !important;
}
.ColumnsPersonalizer_columnEditLine__pw2zC label {
  cursor: pointer;
}
.ColumnsPersonalizer_columnEditLine__pw2zC:hover {
  background-color: #c1e3ff;
}
.ColumnsPersonalizer_columnEditLineCheckBox__TQuYC {
  appearance: none;
  position: relative;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid rgba(28, 57, 187, 0.486);
  cursor: pointer;
}
/* .columnEditLineCheckBox:checked {
  background-color: rgb(28, 57, 187);
  border: none;
}
.columnEditLineCheckBox:checked::before {
  content: "\\2713";
  font-family: Estedad !important;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  position: absolute;
  top: -4px;
  left: 2px;
} */
.ColumnsPersonalizer_actionsContainer__jqpa8 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ColumnsPersonalizer_upAndDownArrowContainer__b-hOa {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 38px;
  padding-inline-start: 7px;
  row-gap: 3px;
}
.ColumnsPersonalizer_upArrow__paIMd {
  transform: rotate(180deg);
}
.ColumnsPersonalizer_downArrow__REZWz {
  transform: translateX(0.8px);
}
.ColumnsPersonalizer_upArrow__paIMd,
.ColumnsPersonalizer_downArrow__REZWz {
  width: 12px !important;
  height: 12px !important;
  cursor: pointer;
}
.ColumnsPersonalizer_disabledColor__QaCOw {
  color: rgb(157, 157, 157, 0.19);
  fill: rgb(157, 157, 157, 0.19);
}
.ColumnsPersonalizer_enabledColor__IEJiO {
  color: #bbc0ca;
  fill: #bbc0ca;
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/ColumnsPersonalizer/ColumnsPersonalizer.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;AACA;;;;;;;;;;;;;GAaG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,aAAa;AACf","sourcesContent":[".checkboxEditColumns {\r\n  color: #787878;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  flex-grow: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.columnEditLine {\r\n  padding: 0 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-direction: row-reverse;\r\n  column-gap: 8px;\r\n  height: 38px !important;\r\n}\r\n.columnEditLine label {\r\n  cursor: pointer;\r\n}\r\n.columnEditLine:hover {\r\n  background-color: #c1e3ff;\r\n}\r\n.columnEditLineCheckBox {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  position: relative;\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: #fff;\r\n  border-radius: 3px;\r\n  border: 1px solid rgba(28, 57, 187, 0.486);\r\n  cursor: pointer;\r\n}\r\n/* .columnEditLineCheckBox:checked {\r\n  background-color: rgb(28, 57, 187);\r\n  border: none;\r\n}\r\n.columnEditLineCheckBox:checked::before {\r\n  content: \"\\2713\";\r\n  font-family: Estedad !important;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  position: absolute;\r\n  top: -4px;\r\n  left: 2px;\r\n} */\r\n.actionsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.upAndDownArrowContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  height: 38px;\r\n  padding-inline-start: 7px;\r\n  row-gap: 3px;\r\n}\r\n.upArrow {\r\n  transform: rotate(180deg);\r\n}\r\n.downArrow {\r\n  transform: translateX(0.8px);\r\n}\r\n.upArrow,\r\n.downArrow {\r\n  width: 12px !important;\r\n  height: 12px !important;\r\n  cursor: pointer;\r\n}\r\n.disabledColor {\r\n  color: rgb(157, 157, 157, 0.19);\r\n  fill: rgb(157, 157, 157, 0.19);\r\n}\r\n.enabledColor {\r\n  color: #bbc0ca;\r\n  fill: #bbc0ca;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxEditColumns": `ColumnsPersonalizer_checkboxEditColumns__ewKms`,
	"columnEditLine": `ColumnsPersonalizer_columnEditLine__pw2zC`,
	"columnEditLineCheckBox": `ColumnsPersonalizer_columnEditLineCheckBox__TQuYC`,
	"actionsContainer": `ColumnsPersonalizer_actionsContainer__jqpa8`,
	"upAndDownArrowContainer": `ColumnsPersonalizer_upAndDownArrowContainer__b-hOa`,
	"upArrow": `ColumnsPersonalizer_upArrow__paIMd`,
	"downArrow": `ColumnsPersonalizer_downArrow__REZWz`,
	"disabledColor": `ColumnsPersonalizer_disabledColor__QaCOw`,
	"enabledColor": `ColumnsPersonalizer_enabledColor__IEJiO`
};
export default ___CSS_LOADER_EXPORT___;
